@import "@/scss/use-bootstrap-mixins.scss";

.container {
  // padding: 8px;
  font-family: 'Poppins', sans-serif;

  @include media-breakpoint-up(lg) {
    // padding: 40px 80px;
    max-width: 954px;
    margin: 0 auto;
  }

  .filterBar {
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(lg) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      gap: 24px;
    }
  }

  .spaceCalculatorTrigger {
    flex-shrink: 0;
    margin: 0 16px 30px;

    @include media-breakpoint-up(lg) {
      margin: 0 0 30px auto;
    }
  }

  .unitTypeGrid {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .emptyState {
    margin: 24px 0;
    padding: 40px 24px;
    text-align: center;
    font-size: 16px;
    color: #666;
    background-color: $primary5Pct;
    border: 1px solid $primaryLightest;
    border-radius: 14px;
  }
}
